import type { Exposure } from "../lib/types";

type Props = { exposure: Exposure | null };

export function ExposureMeter({ exposure }: Props) {
  if (!exposure) {
    return (
      <div className="rounded-md border border-ink-700 bg-ink-900 p-3 text-sm text-slate-400">
        <div className="text-xs uppercase tracking-wider text-slate-500">
          Exposure ceiling
        </div>
        <div className="italic">not set yet — run exposure_coach</div>
      </div>
    );
  }
  const pct = Math.round(exposure.ceiling_pct * 100);
  const color =
    pct >= 80
      ? "bg-accent-ok"
      : pct >= 50
        ? "bg-accent-warn"
        : "bg-accent-err";
  return (
    <div className="rounded-md border border-ink-700 bg-ink-900 p-3">
      <div className="mb-1 flex items-baseline justify-between">
        <div className="text-xs uppercase tracking-wider text-slate-500">
          Exposure ceiling
        </div>
        <div className="text-xs text-slate-500">
          as of <span className="font-mono">{exposure.as_of_et}</span>
        </div>
      </div>
      <div className="flex items-baseline gap-3">
        <div className="font-mono text-2xl text-slate-100">{pct}%</div>
        <div className="text-sm text-slate-400">{exposure.regime}</div>
      </div>
      <div className="mt-2 h-2 w-full overflow-hidden rounded bg-ink-700">
        <div className={`h-full ${color}`} style={{ width: `${pct}%` }} />
      </div>
      {exposure.rationale && (
        <div
          className="mt-2 truncate text-xs text-slate-500"
          title={exposure.rationale}
        >
          {exposure.rationale}
        </div>
      )}
    </div>
  );
}
